import { v4 as uuidv4 } from 'uuid';
import { random } from "lodash";


import BanditScrapperImagePath from '../../assets/images/enemies/Bandit1Scapper.png';
import BanditFighterImagePath from '../../assets/images/enemies/Bandit2Fighter.png';
import BanditBrusierImagePath from '../../assets/images/enemies/Bandit3Bruiser.png';
import BanditBossImagePath from '../../assets/images/enemies/Bandit4Boss.png';

import GobboRuntImagePath from '../../assets/images/enemies/Gobbo1Runt.png';
import GobboWarriorImagePath from '../../assets/images/enemies/Gobbo2Warrior.png';
import GobboHunterImagePath from '../../assets/images/enemies/Gobbo3Hunter.png';
import GobboCasterImagePath from '../../assets/images/enemies/Gobbo4Caster.png';
import GobboBruteImagePath from '../../assets/images/enemies/Gobbo5Brute.png';
import GobboChiefImagePath from '../../assets/images/enemies/Gobbo6Chief.png';

import BossBeastImagePath from '../../assets/images/enemies/TheBeast.png';
import BossBaronImagePath from '../../assets/images/enemies/TheBaron.png';
import BossUgonImagePath from '../../assets/images/enemies/TheUgon.png';


export type TEnemy = {
   id: string;
   name: string;
   imageFilePath: string;
   maxHealth: number;
   currentHealth: number;
   attackMin: number;
   attackMax: number;
   isDead: boolean;
   isActiveTarget: boolean;
   isStunned:boolean;
   resistance:number;
   roundsStunned: number;
};


export const generateRuntGobbo = (): TEnemy => {
   const maxHealth = random(10, 15);
   return {
      id: uuidv4(),
      name: 'Gobbo Runt',
      imageFilePath: GobboRuntImagePath,
      maxHealth: maxHealth,
      currentHealth: maxHealth,
      attackMin: 1,
      attackMax: 4,
      isDead: false,
      isActiveTarget: false,
      isStunned: false,
      resistance: 5,
      roundsStunned:0,
   };
}

export const generateWarriorGobbo = (): TEnemy => {
   const maxHealth = random(15, 18);
   return {
      id: uuidv4(),
      name: 'Gobbo Warrior',
      imageFilePath: GobboWarriorImagePath,
      maxHealth: maxHealth,
      currentHealth: maxHealth,
      attackMin: 2,
      attackMax: 5,
      isDead: false,
      isActiveTarget: false,
      isStunned: false,
      resistance: 20,
      roundsStunned:0,
   };
}

export const generateHunterGobbo = (): TEnemy => {
   const maxHealth = random(13, 18);
   return {
      id: uuidv4(),
      name: 'Gobbo Hunter',
      imageFilePath: GobboHunterImagePath,
      maxHealth: maxHealth,
      currentHealth: maxHealth,
      attackMin: 5,
      attackMax: 8,
      isDead: false,
      isActiveTarget: false,
      isStunned: false,
      resistance: 15,
      roundsStunned:0,
   };
}

export const generateCasterGobbo = (): TEnemy => {
   const maxHealth = random(18, 22);
   return {
      id: uuidv4(),
      name: 'Gobbo Caster',
      imageFilePath: GobboCasterImagePath,
      maxHealth: maxHealth,
      currentHealth: maxHealth,
      attackMin: 5,
      attackMax: 12,
      isDead: false,
      isActiveTarget: false,
      isStunned: false,
      resistance: 20,
      roundsStunned:0,
   };
}

export const generateBruteGobbo = (): TEnemy => {
   const maxHealth = random(35, 65);
   return {
      id: uuidv4(),
      name: 'Gobbo Brute',
      imageFilePath: GobboBruteImagePath,
      maxHealth: maxHealth,
      currentHealth: maxHealth,
      attackMin: 8,
      attackMax: 14,
      isDead: false,
      isActiveTarget: false,
      isStunned: false,
      resistance: 40,
      roundsStunned:0,
   };
}

export const generateChiefGobbo = (): TEnemy => {
   const maxHealth = random(20, 30);
   return {
      id: uuidv4(),
      name: 'Gobbo Chief',
      imageFilePath: GobboChiefImagePath,
      maxHealth: maxHealth,
      currentHealth: maxHealth,
      attackMin: 8,
      attackMax: 12,
      isDead: false,
      isActiveTarget: false,
      isStunned: false,
      resistance: 50,
      roundsStunned:0,
   };
}

export const generateRandomGobbo = (): TEnemy => {
   const allGobbos = [
      generateRuntGobbo(),
      generateWarriorGobbo(),
      generateHunterGobbo(),
      generateCasterGobbo(),
      generateBruteGobbo(),
      generateChiefGobbo(),
   ]
   const randomPick = random(0, allGobbos.length - 1);
   return allGobbos[randomPick];
}


export const generateScrapperBandit = (): TEnemy => {
   const maxHealth = random(20, 30);
   return {
      id: uuidv4(),
      name: 'Bandit Scrapper',
      imageFilePath: BanditScrapperImagePath,
      maxHealth: maxHealth,
      currentHealth: maxHealth,
      attackMin: 2,
      attackMax: 5,
      isDead: false,
      isActiveTarget: false,
      isStunned: false,
      resistance: 20,
      roundsStunned:0,
   };
}

export const generateFighterBandit = (): TEnemy => {
   const maxHealth = random(25, 35);
   return {
      id: uuidv4(),
      name: 'Bandit Fighter',
      imageFilePath: BanditFighterImagePath,
      maxHealth: maxHealth,
      currentHealth: maxHealth,
      attackMin: 4,
      attackMax: 8,
      isDead: false,
      isActiveTarget: false,
      isStunned: false,
      resistance: 30,
      roundsStunned:0,
      
   };
}

export const generateBruiserBandit = (): TEnemy => {
   const maxHealth = random(30, 40);
   return {
      id: uuidv4(),
      name: 'Bandit Bruiser',
      imageFilePath: BanditBrusierImagePath,
      maxHealth: maxHealth,
      currentHealth: maxHealth,
      attackMin: 5,
      attackMax: 9,
      isDead: false,
      isActiveTarget: false,
      isStunned: false,
      resistance: 40,
      roundsStunned:0,
   };
}

export const generateBossBandit = (): TEnemy => {
   const maxHealth = random(50, 70);
   return {
      id: uuidv4(),
      name: 'Bandit Boss',
      imageFilePath: BanditBossImagePath,
      maxHealth: maxHealth,
      currentHealth: maxHealth,
      attackMin: 7,
      attackMax: 10,
      isDead: false,
      isActiveTarget: false,
      isStunned: false,
      resistance: 50,
      roundsStunned:0,
   };
}

export const generateRandomBandit = (): TEnemy => {
   const allBandits = [
      generateScrapperBandit(),
      generateFighterBandit(),
      generateBruiserBandit(),
      generateBossBandit()
   ]
   const randomPick = random(0, allBandits.length - 1);
   return allBandits[randomPick];
}




export const generateBeastBoss = (): TEnemy => {
   const maxHealth = random(90, 110);
   return {
      id: uuidv4(),
      name: 'The Beast',
      imageFilePath: BossBeastImagePath,
      maxHealth: maxHealth,
      currentHealth: maxHealth,
      attackMin: 10,
      attackMax: 14,
      isDead: false,
      isActiveTarget: false,
      isStunned: false,
      resistance: 70,
      roundsStunned:0,
   };
}

export const generateBaronBoss = (): TEnemy => {
   const maxHealth = random(80, 90);
   return {
      id: uuidv4(),
      name: 'The Baron',
      imageFilePath: BossBaronImagePath,
      maxHealth: maxHealth,
      currentHealth: maxHealth,
      attackMin: 11,
      attackMax: 15,
      isDead: false,
      isActiveTarget: false,
      isStunned: false,
      resistance: 80,
      roundsStunned:0,
   };
}

export const generateUgonBoss = (): TEnemy => {
   const maxHealth = random(110, 130);
   return {
      id: uuidv4(),
      name: 'The Ugon',
      imageFilePath: BossUgonImagePath,
      maxHealth: maxHealth,
      currentHealth: maxHealth,
      attackMin: 8,
      attackMax: 18,
      isDead: false,
      isActiveTarget: false,
      isStunned: false,
      resistance: 60,
      roundsStunned:0,
   };
}

